function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.64299 7.32739H3.88037C3.75425 7.67271 3.68534 8.04536 3.68534 8.43377V13.1104C3.68534 13.2723 3.71353 13.4277 3.76481 13.5723H1.71914C0.954981 13.5723 0.333322 12.9506 0.333322 12.1865V9.63706C0.333291 8.36352 1.36942 7.32739 2.64299 7.32739Z",
  fill: "#99A6B0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9812 8.43402C12.9812 8.04558 12.9123 7.67295 12.7862 7.32764H14.0235C15.2971 7.32764 16.3333 8.36377 16.3333 9.63734V12.1868C16.3333 12.9509 15.7116 13.5726 14.9474 13.5726H12.9017C12.953 13.428 12.9812 13.2725 12.9812 13.1106V8.43402Z",
  fill: "#99A6B0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.91884 6.12451H9.74767C11.0212 6.12451 12.0574 7.16064 12.0574 8.43421V13.1108C12.0574 13.3659 11.8506 13.5727 11.5954 13.5727H5.07108C4.81596 13.5727 4.60914 13.3659 4.60914 13.1108V8.43421C4.60914 7.16064 5.64527 6.12451 6.91884 6.12451Z",
  fill: "#99A6B0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.33314 0C9.86477 0 11.1108 1.24607 11.1108 2.77773C11.1108 3.81665 10.5374 4.724 9.69061 5.20038C9.28895 5.42631 8.82589 5.55544 8.33314 5.55544C7.84038 5.55544 7.37732 5.42631 6.97566 5.20038C6.12881 4.724 5.55543 3.81662 5.55543 2.77773C5.55543 1.2461 6.8015 0 8.33314 0Z",
  fill: "#99A6B0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2107 2.58911C14.3562 2.58911 15.2881 3.52099 15.2881 4.66647C15.2881 5.81194 14.3562 6.74382 13.2107 6.74382C12.9202 6.74382 12.6435 6.68364 12.3921 6.57545C11.9576 6.38835 11.5993 6.05716 11.3775 5.64232C11.2219 5.35116 11.1334 5.019 11.1334 4.66647C11.1334 3.52102 12.0653 2.58911 13.2107 2.58911Z",
  fill: "#99A6B0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M3.4556 2.58911C4.60108 2.58911 5.53296 3.52099 5.53296 4.66647C5.53296 5.01903 5.44443 5.35119 5.2888 5.64232C5.06708 6.05719 4.70877 6.38838 4.2742 6.57545C4.02286 6.68364 3.74617 6.74382 3.4556 6.74382C2.31013 6.74382 1.37825 5.81194 1.37825 4.66647C1.37825 3.52099 2.31013 2.58911 3.4556 2.58911Z",
  fill: "#99A6B0"
});

const SvgUsersIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 14,
  viewBox: "0 0 17 14",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUsersIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/users-icon.c0bb8be5.svg";
export { ForwardRef as ReactComponent };